import { render } from "./OrderTracking.vue?vue&type=template&id=65421dec&scoped=true&ts=true"
import script from "./OrderTracking.vue?vue&type=script&lang=ts"
export * from "./OrderTracking.vue?vue&type=script&lang=ts"

import "./OrderTracking.vue?vue&type=style&index=0&id=65421dec&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65421dec"]])

export default __exports__